import React from 'react'
import { PageTitle } from '@/layout-components'
import { ExampleWrapperSeamless } from '@/layout-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Grid, Backdrop, CircularProgress } from '@mui/material'

/**
 * Shared layout component for public pages
 * Provides consistent structure with PageTitle and ExampleWrapperSeamless
 */
const PublicPageLayout = ({
  title,
  description,
  icon,
  logoSrc,
  logoAlt,
  children,
  loading = false,
  error = null,
  style = { margin: 0 },
  containerProps = {},
  ...props
}) => {
  if (loading) {
    return (
      <Backdrop
        open={loading}
        style={{
          color: '#fff',
          zIndex: 2000,
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    )
  }

  if (error) {
    return <p>Error: {error.message}</p>
  }

  return (
    <>
      <PageTitle
        titleHeading={title}
        titleDescription={description}
        logoSrc={logoSrc}
        logoAlt={logoAlt}
        icon={
          !logoSrc && icon ? (
            <FontAwesomeIcon
              icon={icon}

              style={{ fontSize: 30 }}
              sx={{ color: '#368cff' }}
            />
          ) : null
        }
        style={style}
      />
      <ExampleWrapperSeamless>
        <Grid
          container
          sx={{ width: '100%', flex: '1 1 auto', minWidth: 0 }}
          {...containerProps}
        >
          {children}
        </Grid>
      </ExampleWrapperSeamless>
    </>
  )
}

export default PublicPageLayout
